import { useI18n } from 'vue-i18n'
import { watch } from 'vue'
import flatpickr from 'flatpickr'

// Import flatpickr locales
import { Spanish } from 'flatpickr/dist/l10n/es.js'

const flatpickrLocales = {
  es: Spanish,
  en: undefined, // English is default
}

export function useFlatpickrLocale() {
  const { locale } = useI18n()

  const setFlatpickrLocale = (localeCode: string) => {
    const localeData = flatpickrLocales[localeCode as keyof typeof flatpickrLocales]
    if (localeData) {
      flatpickr.localize(localeData)
    }
  }

  // Set initial locale
  setFlatpickrLocale(locale.value)

  // Watch for locale changes
  watch(locale, (newLocale) => {
    setFlatpickrLocale(newLocale)
  })

  return {
    setFlatpickrLocale,
  }
}
